import { Box, Stack, Typography } from "@mui/material"
import React from "react"
import { useTranslation } from "react-i18next"
import LanguageSelector from "../../../LanguageSelector"

const CheckoutHeader7 = () => {
  const { t } = useTranslation()

  return (
    <Box position="absolute" left="0px" right="0px" top="0px" zIndex={1000}>
      <Stack
        sx={{
          py: 2,
          width: "100%",
          background: "linear-gradient(180deg, #4bdba6, #3ebf90)",
          color: "white",
        }}
      >
        <Stack
          direction="row"
          spacing={2}
          alignItems="center"
          alignContent="center"
          justifyContent="center"
          sx={{ width: "100%", position: "relative" }}
        >
          <Stack
            direction="row"
            spacing={2}
            alignItems="center"
            alignContent="center"
          >
            <Typography fontSize="15px" lineHeight="15px" fontWeight={400}>
              {t("checkout.v7.header")}
            </Typography>
          </Stack>
          <LanguageSelector
            color="white"
            sx={{ position: "absolute", right: { xs: 8, sm: 24 }, top: "50%", transform: "translateY(-50%)" }}
          />
        </Stack>
      </Stack>
    </Box>
  )
}

export default CheckoutHeader7
